/** Defects & Punch List presentation meta (Phase 87). */

export const DEFECT_STATUS_META = {
  open: { label: "Open", short: "Open", cls: "border-border bg-muted text-muted-foreground", dot: "bg-muted-foreground" },
  in_progress: { label: "In progress", short: "In progress", cls: "border-sky-500/30 bg-sky-500/10 text-sky-300", dot: "bg-sky-400" },
  rectified: { label: "Rectified — to verify", short: "To verify", cls: "border-amber-500/30 bg-amber-500/10 text-amber-300", dot: "bg-amber-400" },
  verified: { label: "Verified", short: "Verified", cls: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300", dot: "bg-emerald-400" },
  closed: { label: "Closed", short: "Closed", cls: "border-border bg-muted/60 text-muted-foreground line-through decoration-muted-foreground/50", dot: "bg-muted-foreground/60" },
};

export const DEFECT_STATUS_ORDER = ["open", "in_progress", "rectified", "verified", "closed"];

export const DEFECT_PRIORITY_META = {
  critical: { label: "Critical", cls: "border-rose-500/40 bg-rose-500/10 text-rose-300", bar: "bg-rose-500" },
  major: { label: "Major", cls: "border-amber-500/40 bg-amber-500/10 text-amber-300", bar: "bg-amber-500" },
  minor: { label: "Minor", cls: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300", bar: "bg-emerald-500" },
};

export const DEFECT_PRIORITIES = ["critical", "major", "minor"];

export const HISTORY_META = {
  raised: { label: "Raised", tone: "text-primary" },
  edited: { label: "Edited", tone: "text-muted-foreground" },
  bulk_update: { label: "Updated in bulk", tone: "text-muted-foreground" },
  trade_notified: { label: "Trade notified", tone: "text-muted-foreground" },
  started: { label: "Started by trade", tone: "text-sky-300" },
  rectified: { label: "Marked rectified", tone: "text-amber-300" },
  verified: { label: "Verified", tone: "text-emerald-300" },
  rejected: { label: "Rejected — reopened", tone: "text-rose-300" },
  closed: { label: "Closed", tone: "text-muted-foreground" },
  reopened: { label: "Reopened", tone: "text-rose-300" },
  comment: { label: "Comment", tone: "text-muted-foreground" },
  notice_issued: { label: "Formal defect notice issued", tone: "text-orange-300" },
  followup_sent: { label: "Day-before reminder emailed to trade", tone: "text-orange-300" },
  trade_booked: { label: "Trade booked in", tone: "text-primary" },
  completion_letter_sent: { label: "Completion letter emailed to client", tone: "text-emerald-300" },
  completion_letter_downloaded: { label: "Completion letter downloaded", tone: "text-muted-foreground" },
};

export const UNASSIGNED = "__unassigned__";
export const NO_AREA = "__none__";

export const fmtHistoryMeta = (h) => {
  const m = h?.meta || {};
  const bits = [];
  if (m.priority) bits.push(`priority ${m.priority}`);
  if (m.due_date) bits.push(`due ${m.due_date}`);
  if (m.trade) bits.push(`trade ${m.trade}`);
  if (m.reason_label) bits.push(m.reason_label);
  if (m.photos_added) bits.push(`${m.photos_added} photo${m.photos_added === 1 ? "" : "s"}`);
  if (m.recipients?.length) bits.push(m.recipients.join(", "));
  if (m.letter_number) bits.push(m.letter_number);
  if (m.to) bits.push(`to ${m.to}`);
  if (m.scheduled_date) bits.push(`scheduled ${m.scheduled_date}`);
  return bits.join(" · ");
};
